<template>
  <svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg"
       xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>6ED8B4D5-C6E0-4579-BD1B-FEFC2F8A419C</title>
    <defs>
      <filter id="filter-1">
        <feColorMatrix in="SourceGraphic" type="matrix"
                       values="0 0 0 0 0.207843 0 0 0 0 0.572549 0 0 0 0 1.000000 0 0 0 1.000000 0"></feColorMatrix>
      </filter>
    </defs>
    <g id="Apps" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="Dashboard---Compliance" transform="translate(-998.000000, -349.000000)">
        <rect fill="#FFFFFF" x="0" y="0" width="1440" height="1026"></rect>
        <g id="Control" transform="translate(367.000000, 349.000000)">
          <g id="Filters" transform="translate(631.000000, 0.000000)">
            <g filter="url(#filter-1)" id="Variables/Icon/Add">
              <g>
                <g id="Group" fill="#000000" fill-rule="nonzero">
                  <path
                      d="M24,12.68 L24,11 L9,11 L9,12.68 L24,12.68 Z M21.5,16.82 L21.5,15.18 L11.5,15.18 L11.5,16.82 L21.5,16.82 Z M18.18,21 L18.18,19.32 L14.82,19.32 L14.82,21 L18.18,21 Z"></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'FilterIcon',
};
</script>
